<template>
  <div
    v-if="showPagination"
    class="pagination d-flex align-center justify-space-between pa-2">
    <div v-if="showTotal" class="text-body-2 text-grey-darken-1">
      Показано
      <span class="font-weight-bold text-grey-darken-4">
        {{ from }}–{{ to }} з {{ total }}
      </span>
    </div>
    <div v-else></div>

    <div class="d-flex justify-end flex-column align-end">
      <v-pagination
        v-model="page"
        :length="length"
        density="comfortable"
        rounded="4"
        size="small"
        total-visible="4">
        <template #prev="props">
          <v-btn
            border
            class="pagination__nav-btn"
            color="white"
            v-bind="getButtonProps(props)">
            <v-icon size="small" icon="mdi-chevron-left"></v-icon>
            <span class="font-weight-medium">Назад</span>
          </v-btn>
        </template>
        <template #next="props">
          <v-btn
            border
            class="pagination__nav-btn"
            color="white"
            v-bind="getButtonProps(props)">
            <span class="font-weight-medium">Далі</span>
            <v-icon size="small" icon="mdi-chevron-right"></v-icon>
          </v-btn>
        </template>
        <template #item="{ page, isActive, props }">
          <v-btn
            border
            :class="{ 'pagination__item-btn--active': isActive }"
            class="pagination__item-btn"
            color="white"
            min-height="32px"
            min-width="32px"
            size="x-small"
            v-bind="getItemButtonProps(props)">
            <span :class="isActive ? 'font-weight-bold' : 'font-weight-medium'">
              {{ page }}
            </span>
          </v-btn>
        </template>
      </v-pagination>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue'

export default {
  emits: ['update:model-value'],
  props: {
    modelValue: { type: Number },
    length: { type: Number },
    total: { type: Number },
    from: { type: Number },
    to: { type: Number },
  },
  setup(props, { emit }) {
    const page = computed({
      get() {
        return props.modelValue
      },
      set(v) {
        emit('update:model-value', v)
      },
    })

    const getButtonProps = (buttonProps: Record<string, unknown>) => {
      const rest = { ...buttonProps }

      delete rest.icon

      return rest
    }

    const getItemButtonProps = (buttonProps: Record<string, unknown>) => {
      const rest = { ...buttonProps }

      delete rest.color

      return rest
    }

    const showPagination = computed(() => Number(props.length) > 1)
    const showTotal = computed(() =>
      Boolean(props.from && props.to && props.total)
    )

    return {
      getButtonProps,
      getItemButtonProps,
      page,
      showPagination,
      showTotal,
    }
  },
}
</script>

<style scoped lang="scss">
.pagination {
  background: #f5f5f5;
  border: 1px solid #e7e7e7 !important;
  border-radius: 0 0 8px 8px !important;
  margin-top: -1px;
}

.pagination__nav-btn {
  width: auto !important;
  min-width: 68px !important;
  padding: 0 10px !important;
  max-height: 32px;
}

.pagination__item-btn {
  width: 32px !important;
  min-width: 32px !important;
  max-height: 32px;
}

.pagination__item-btn--active {
  background: #185fa5 !important;
  border: 1px solid #185fa5 !important;
  color: #ffffff !important;
}
</style>
